export const PUBLIC_PROJECTION_KEYS = [
  "availability",
  "expires_at",
  "title",
  "description_public",
  "presentation_note",
  "property_type",
  "deal_type",
  "price",
  "location",
  "facts",
  "features",
  "media",
  "video_url",
  "contact",
];

export const FORBIDDEN_PUBLIC_RENDER_KEYS = [
  "token",
  "share_token",
  "internal_label",
  "client",
  "unique_views",
  "last_viewed_at",
  "phone_cta_count",
  "email_cta_count",
  "description_private",
  "id",
  "is_active",
  "is_active_now",
  "revoked_at",
  "rotated_at",
  "created_at",
  "updated_at",
  "media_selection",
  "include_video",
  "price_mode",
  "location_precision",
  "custom_price",
  "custom_currency",
  "public_url",
  "created_by",
  "realtor",
  "property",
  "land_parcels",
  "cadastral_number",
  "cooperation_offer",
  "cooperation_offer_enabled",
  "views_count",
  "likes_count",
  "bookmarks_user_count",
  "bookmarks_anon_count",
  "liked_by_me",
  "bookmarked_by_me",
  "moderation_hidden_at",
  "is_moderation_locked",
  "visitor_hash",
  "ip",
  "user_agent",
];

export function pickPublicProjection(payload) {
  if (!payload || typeof payload !== "object") return null;
  const next = {};
  PUBLIC_PROJECTION_KEYS.forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(payload, key)) {
      next[key] = payload[key];
    }
  });
  FORBIDDEN_PUBLIC_RENDER_KEYS.forEach((key) => {
    delete next[key];
  });
  return next;
}

export function projectionContainsForbidden(payload) {
  if (!payload || typeof payload !== "object") return false;
  return FORBIDDEN_PUBLIC_RENDER_KEYS.some((key) =>
    Object.prototype.hasOwnProperty.call(payload, key),
  );
}

export const MEDIA_CEILING = 80;
export const NOTE_MAX_LENGTH = 1000;
export const LABEL_MAX_LENGTH = 80;
